<template>
	<div class="status-bar flex-space-between--center" v-show="totalPageNum !== 0">
		<OutlinedButton v-if="addRowEnabled" width="100px" height="24" @click="$emit('addRow')">Add row</OutlinedButton>
		<div class="flex-centerize" v-if="(selectedRows.filter((r) => Object.keys(r).length > 0) || []).length > 0">
			<div class="mr-3">{{ selectedRows.length }} selected</div>
			<OutlinedButton height="24" color="red" width="100px" @click="$emit('reset')">Clear selection</OutlinedButton>
		</div>
		<div v-else class="dummy-div" />
		<div class="flex-centerize" v-if="gridApi">
			<div class="flex-centerize">
				<div>Rows</div>
				<AppSelect class="page-size-selector" outlined dense v-model="pageSizeLocal" :items="pageSizeItems" />
			</div>
			<div class="num-page-text ml-3">{{ currentPage }} of {{ totalPageNum }}</div>
			<RoundButton class="page-btn" :disabled="currentPage <= 1" @click="$emit('gotoPage', currentPage - 1)">
				<ArrowSvg />
			</RoundButton>
			<RoundButton class="page-btn" :disabled="currentPage >= totalPageNum" @click="$emit('gotoPage', currentPage + 1)">
				<ArrowSvg class="right-arrow" />
			</RoundButton>
		</div>
	</div>
</template>

<script>
import OutlinedButton from '@/components/atoms/buttons/OutlinedButton.vue';
import ArrowSvg from './assets/ArrowSvg.vue';
import TableActionEditorService from '@/components/BlockEditor/TableActionEditor/table-action-edtior-service';
export default {
	name: 'TableStatusBar',
	components: {
		ArrowSvg,
		OutlinedButton,
	},
	props: {
		gridApi: { type: Object },
		columnDefs: { type: Array },
		rows: { type: Array },
		selectedRows: { type: Array, default: () => [] },
		pageSize: { type: [String, Number] },
		currentPage: { type: Number },
		totalPageNum: { type: Number },
		addRowEnabled: { type: Boolean },
	},
	computed: {
		pageSizeLocal: {
			get() {
				return this.pageSize;
			},
			set(v) {
				this.$emit('update:pageSize', v);
			},
		},
	},
	data() {
		return {
			pageSizeItems: TableActionEditorService.pageSizeItems,
		};
	},
};
</script>

<style scoped lang="scss">
$status-bar-height: 44px;
$border-color: #dfe4ef;
$border-radius: 4px;

.status-bar {
	height: $status-bar-height;
	$margin: 16px;

	padding: 4px 16px;
	border: 1px solid $border-color;
	border-top-left-radius: 0;
	border-top-right-radius: 0;
	border-bottom-right-radius: $border-radius;
	border-bottom-left-radius: $border-radius;
	border-top: 0;
	font-size: 12px;
	font-weight: 300;
	text-align: left;
	color: #4d4c52;

	.page-size-selector {
		$h: 28px;

		height: calc(#{$h} - 4px);
		width: 50px;
		margin: 0 $margin;

		::v-deep(.v-select) {
			fieldset {
				height: $h;
				border-radius: 2px;
				border-color: #dcdfe6;
			}
			.v-input__append-inner {
				width: 16px;
				margin: 0 !important;
			}
			.v-select__selection {
				min-width: 40px;
			}
			.v-select__selections .v-input__append-inner,
			.v-select__slot {
				height: $h;
			}
			.v-input__slot {
				min-height: $h;
			}
			.v-icon::before {
				font-size: 12px !important;
				color: #606266;
			}
			.v-select__selection--comma {
				margin: -4px 0 0 0;
			}
			input {
				display: none;
			}
		}
	}

	.num-page-text {
		margin: 0 $margin;
	}
	.page-btn {
		margin: 0 $margin;

		&:not(:hover) {
			background-color: transparent !important;
		}
	}

	@media (max-width: $device-sm) {
		padding: 4px 8px;
		font-size: 9px;

		::v-deep(.v-btn).outlined-button {
			width: 80px !important;
			font-size: 9px !important;
		}
		::v-deep(.v-input__slot) {
			font-size: 9px !important;
		}
		.page-size-selector,
		.num-page-text,
		.page-btn {
			margin: 0 4px;
		}
	}
}

.right-arrow {
	transform: rotate(180deg);
}

::v-deep(.outlined-button).v-btn {
	color: #606266 !important;
	font-size: 12px !important;
}
</style>
